import * as React from "react";
import {Accordion as BootstrapAccordion, Col, Row} from "react-bootstrap";
import {Details} from "./items/details";
import {Specifications} from "./items/specifications";
import {Ratings} from "./items/ratings";
import {QuestionAndAnswers} from "./items/questionAndAnswers";
import {useAccordionVariables} from "../../../../hooks/useAccordionVariables";
import {ErrorBoundary} from "@sentry/react";
import {useRefsContext} from "../../../../utils/refContext";
import {AccordionItemType} from "../../../../definitions/enums";

export const Content = () => {
    const {productDetailsAccordionRef, ratingsAccordionItemRef} = useRefsContext();
    const {
        variables: {
            activeKey,
            flush,
            alwaysOpen
        }
    } = useAccordionVariables();
    return (
        <Row className="mx-auto d-block my-3">
            <Col>
                <BootstrapAccordion id="product-details-accordion"
                                    activeKey={activeKey}
                                    flush={flush}
                                    alwaysOpen={alwaysOpen}
                                    ref={productDetailsAccordionRef}>
                    <BootstrapAccordion.Item id="product-details"
                                             eventKey={AccordionItemType.ProductDetails}>
                        <Details/>
                    </BootstrapAccordion.Item>
                    <BootstrapAccordion.Item id="product-specs" eventKey={AccordionItemType.Specifications}>
                        <Specifications/>
                    </BootstrapAccordion.Item>
                    <BootstrapAccordion.Item id="product-qa" eventKey={AccordionItemType.QuestionAndAnswers}>
                        <QuestionAndAnswers/>
                    </BootstrapAccordion.Item>
                    <ErrorBoundary fallback={<></>}>
                        <BootstrapAccordion.Item id="product-reviews"
                                                 eventKey={AccordionItemType.Reviews}
                                                 ref={ratingsAccordionItemRef}>
                            <Ratings/>
                        </BootstrapAccordion.Item>
                    </ErrorBoundary>
                </BootstrapAccordion>
            </Col>
        </Row>
    )
}